// extracted by mini-css-extract-plugin
export default {"list":"styles_list__8Vc7a","notification":"styles_notification__WWO1k","notificationWrapper":"styles_notificationWrapper__I+PYq","empty":"styles_empty__v-whh"};